import { API } from "../../../api/api";
import { KeyAPIRoutes } from "./apiRoutes";

const getKeyRequests = ({ skip, top }) => {
    return API.request({
        routeID: KeyAPIRoutes.GET_KEY_REQUESTS,
        odataParameters: {
            skip,
            top,
            orderby: "-id"
        }
    });
};

const getCounterKey = ({ password, usage, notes }) => {
    return API.request({
        routeID: KeyAPIRoutes.CONFIGURATION_COUNTER_KEY,
        parameters: {
            password,
            usage,
            notes
        }
    });
};

const getHistoryUsersById = ({ ids }: { ids: number[] }) => {
    return API.request({
        routeID: KeyAPIRoutes.GET_HISTORY_USERS,
        odataParameters: {
            skip: 0,
            top: 1000000,
            ...(ids.length && { filter: `id in (${ids.map(c => c).join(",")},)` }),
            orderby: "-id"
        }
    });
};

export const keyAPI = {
    getKeyRequests,
    getCounterKey,
    getHistoryUsersById
};
